import { createEntry, insertCss } from "@/helpers/entriesHelper";
import List from "@/views/List/List.vue";
createEntry(List, "eopoi-app-widget");
insertCss();
